module.exports = __webpack_public_path__ + "static/media/muji ui3.b0f301ad.png";